import { render, staticRenderFns } from "./activity-create.vue?vue&type=template&id=49ffbc7b&scoped=true&"
import script from "./activity-create.vue?vue&type=script&lang=js&"
export * from "./activity-create.vue?vue&type=script&lang=js&"
import style0 from "./activity-create.vue?vue&type=style&index=0&id=49ffbc7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ffbc7b",
  null
  
)

component.options.__file = "activity-create.vue"
export default component.exports